import ACTIONS from '../actions';
import * as AppState from '../app/appState';
import { getStore, getState } from '../../store';
import * as Cookie from '../../../lib/cookie';
import CONF from '../../../api/config';

export const authWithCookie = async sessionToken => {
    if (sessionToken === 'null') {
        AppState.routeToLogin();
        return;
    }

    setSessionToken({ session_id: sessionToken });
    await AppState.getCurrentLoggedInUser();
    getStore().dispatch({
        type: ACTIONS.AUTH_SUCCESS
    });
};

export const checkToken = () => {
    const cookieToken = Cookie.getCookie(CONF.SESSION_NAME);
    const stateToken = getState().auth.token;

    if (!cookieToken) {
        AppState.routeToLogin();
    } else if (cookieToken === stateToken) {
        return AppState.getCurrentLoggedInUser();
    }

    return authWithCookie(cookieToken);
};

export const setSessionToken = token => {
    getStore().dispatch({
        type: ACTIONS.AUTH_SET_SESSION_TOKEN,
        token
    });
};



// WEBPACK FOOTER //
// ./src/state/reducer/auth/auth.js